import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@shared/services/authentication.service';

export const UnAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
    return authService.isAuth().then(isAuth => {
      if (isAuth) {
        authService.redirectURL = state.url;
        return router.parseUrl('/');
      }
      return true;
    });
};
